import { devtools, persist } from "zustand/middleware";

import { create } from "./helpers/resetStore.helper";
import AppLanguage from "../constants/appLanguage.enum";
import i18n from "../locale";

interface AppLanguageState {
  appLanguage: AppLanguage;
  setAppLanguage: (language: AppLanguage) => void;
  reset: () => void;
}

const useAppLanguageStore = create<AppLanguageState>(
  devtools(
    persist(
      (set) => ({
        appLanguage: AppLanguage.English,
        setAppLanguage: (language: AppLanguage) => {
          set({ appLanguage: language });
          void i18n.changeLanguage(language);
        },
        reset: () => {
          set({ appLanguage: AppLanguage.English });
        },
      }),
      {
        name: "app-language-storage",
      }
    )
  )
);

export default useAppLanguageStore;
